import { Component, OnInit, Input, AfterViewInit, ViewContainerRef, ViewChild } from '@angular/core';
import get from 'lodash-es/get';

import { MapDataLocationMarker, MarkerOptions, MapInterface } from '@finder/shared/components/map/map/map.interface';
import { LazyLoaderService } from '@finder/shared/services/lazy-loader/lazy-loader-service';
import { CommonModule } from '@angular/common';
import { ComponentHeaderComponent } from '../component-header/component-header.component';
import { FontIconComponent } from '../font-icon/font-icon.component';
import { MapComponent } from '../map/map.component';

@Component({
    selector: 'finder-campaign-map',
    templateUrl: './campaign-map.component.html',
    styleUrls: ['./campaign-map.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        ComponentHeaderComponent,
        FontIconComponent,
        MapComponent,
    ],
})
export class CampaignMapComponent implements OnInit {
    @Input() mapData: any;

    defaults: any;
    markers: Array<MapDataLocationMarker>;
    center: MapDataLocationMarker;
    maxBounds: any;
    paradeRoute: Array<MapDataLocationMarker>;
    link: string;
    linkText: string;
    markerOptions: MarkerOptions;

    constructor() {}

    ngOnInit() {
        // Set the defaults
        this.defaults = Object.assign(this.mapData.location.defaults, {
            doubleClickZoom: true,
            scrollWheelZoom: true,
        });

        // Add a recenter control to the map
        this.defaults.addRecenterControl = {
            title: this.mapData.recenterTitle,
            icon: 'recenter-icon',
            callback: (mapObj: MapInterface, $event) => {
                // eat the click event
                $event.preventDefault();

                // Focus on the pins
                mapObj.focusOnPins(this.markerOptions);
            }
        };

        // Create the marker
        this.markers = this.mapData.location.markers;

        // Look for route information and add it to the map
        this.paradeRoute = get(this.mapData, 'location.paradeRoute');

        // Set marker options
        this.markerOptions = {
            showPopup: true,
            // Allow the arrow keys to move the map
            keyboard: true,
            allowClustering: true,
            allowMarkerMouseOver: true,
            padding: [100, 100]
        };

        // Center the map on the marker
        this.center = get(this.mapData, 'location.defaults.center');

        if (this.center) {
            // Avoiding undefined errors
            this.center.zoom = this.defaults.zoom;
        }
    }
}
